<template>
  <PublicPopup ref="PopupRef" title="Lembrete" :closeable="false" @close="emit('close')">
    <template #content>
      <div class="lembrete-popup chxy-column-c-c">
        <div class="desc">
          Esta conta foi acessada em outro dispositivo. Se nǎofor o seu dispositivo, acesse
          imediatamente a "P¡ginade Login do Dispositivo" para excluir este dispositivo
        </div>
        <div class="btn-view" @click="handlePopupClose">Confimmar</div>
      </div>
    </template>
  </PublicPopup>
</template>

<script setup>
const PopupRef = ref(null)
const open = () => {
  nextTick(() => {
    PopupRef.value.open()
  })
}
const handlePopupClose = () => {
  PopupRef.value.close()
  // window.location.href = '/'
}

const emit = defineEmits(['close'])

defineExpose({
  open,
})
</script>

<style lang="scss" scoped>
.lembrete-popup {
  .desc {
    margin: 10px auto 15px;
    padding: 0 15px;
    font-size: 14px;
    color: var(--lembrete-popup-content-text);
  }
  .btn-view {
    width: 100%;
    height: 35px;
    line-height: 35px;
    text-align: center;
    background: var(--lembrete-popup-confirm-bg);
    color: var(--lembrete-popup-confirm-text);
    font-size: 14px;
    border-radius: 5px;
  }
}
</style>
